import LearnerProficiencyChart from '@/components/charts/learner-proficiency-chart/learner-proficiency-chart';
import TaxonomyFilter from '@/components/selector/taxonomy-filter/taxonomy-filter';
import { SubjectModel } from '@/models/taxonomy/subject';
import { profileAPI } from '@/providers/apis/profile/profile';
import Behavior from '@/routers/views/learners/learner-identity/behavior/behavior';
import moment from 'moment';
import { Vue, Component, Prop } from 'vue-property-decorator';
import StudentRoundViewComponent from '../student-round-view/student-round-view';

@Component({
    name: 'student-tree-chart',
    components: {
        'behavior': Behavior,
        'learner-proficiency-chart-content': LearnerProficiencyChart,
        'student-round-view': StudentRoundViewComponent,
    },
})

export default class StudentTreeChartComponent extends Vue {

    // -----------------------------------------------------------
    // Properties

    private taxonomyFiler: TaxonomyFilter = new TaxonomyFilter();

    @Prop({default: 'popover'})
    private elementId!: string;

    @Prop({default: 'e8a409f5-7fd9-4027-8955-3eda9322413f'})
    private studentId!: string;

    @Prop()
    private isShowCaseView!: boolean;

    @Prop()
    private isStrugglingStudentView!: boolean;

    private selectedSubjects: any = [];

    private treeBox: any = [
        {
            name: 'Behavior',
            icon: 'light_mode',
        },
        {
            name: 'Context',
            icon: 'ac_unit',
        },
        {
            name: 'Biographical',
            icon: 'contacts',
        },
    ];

    private studentDetails: any = {};

    private isLoading: boolean = false;


    // -----------------------------------------------------------
    // Hooks

    private created() {
        this.fetchUserDetails();
    }

    private mounted() {
        this.fetchTaxonomyFilter();
        this.$nextTick().then(() => {
            this.$root.$emit('bv::show::popover');
        });
    }

    // -----------------------------------------------------------
    // Actions

    private onShowFacets() {
        let pathUrl = `/learners/${this.studentId}?filter=true`;
        if (this.isShowCaseView) {
            pathUrl += '&isShowCaseView=true';
        }
        this.$router.push(pathUrl);
    }

    private onShowProficiency(box: any) {
        const componentData = box.componentData ? box.componentData.propData.subject : null;
        if (componentData) {
            const activeSubject = JSON.stringify(componentData);
            let pathUrl = `/learners/${this.studentId}?filter=true&activeSubject=${window.btoa(encodeURIComponent(activeSubject))}`;
            if (this.isShowCaseView) {
                pathUrl += '&isShowCaseView=true';
            }
            this.$router.push(pathUrl);
        }
    }

    private fetchUserDetails() {
        profileAPI.fetchUserProfiles(this.studentId).then((userDetails) => {
            this.studentDetails = userDetails[0];
        });
    }

    private fetchTaxonomyFilter() {
        this.isLoading = true;
        this.taxonomyFiler.loadFilterOutside(this.studentId);
        this.taxonomyFiler.$on('listActiveFacets', (activeFacts: SubjectModel[]) => {
            if (!this.selectedSubjects.length) {
                this.selectedSubjects = [...new Map(activeFacts.map((item) => [item.id, item])).values()];
                const subjectItems = this.selectedSubjects.map(this.createSubjectCard);
                this.treeBox = [...subjectItems, ...this.treeBox];
                this.isLoading = false;
                setTimeout(() => {this.$root.$emit('bv::show::popover'); }, 500);
            }
          });
    }

    private createSubjectCard(subject: any) {
        return {
            name: subject.title,
            icon: 'library_books',
            componentData: {
                name: 'learner-proficiency-chart-content',
                propData: {
                    subject: {
                        code: subject.code,
                        id: subject.code,
                        title: subject.title,
                    },
                    userId: this.studentId,
                    month: moment().format('MM'),
                    year: moment().format('YYYY'),
                    subjectCode: subject.code,
                    isCardView: true,
                },
            },
        };
    }

}
